export const PR_V2_VIEW_PREFERENCES_STORAGE_KEY = 'pr-v2-diff-preferences-v1';
// Write target for the PR SidebarProvider's cookie effect. Nothing reads it
// anymore; PR v2 derives its initial session state from the active layout. It
// exists so the provider does not write the generic 'sidebar:state' cookie
// other layouts consume.
export const PR_V2_RIGHT_SIDEBAR_COOKIE_NAME = 'pr-v2-right-sidebar:state';
// Width the PR layout gives the chat sidebar before any drag-to-resize. The
// resized value persists in the shared 'sidebar:width' cookie; layouts pass
// that cookie back as defaultWidth so SSR matches. Nothing may change the
// width after mount: the whole PR column would jump sideways on every open.
export const PR_V2_CHAT_SIDEBAR_DEFAULT_WIDTH = '20rem';
export const PR_V2_CHAT_SIDEBAR_MOBILE_WIDTH = 'min(26rem, 92vw)';
